import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import NavbarBrand from "./NavbarBrand.js";
import NavbarButtons from "./NavbarButtons.js";
import NavbarMenu from "./NavbarMenu.js";
import SearchBar from "./SearchBar.js";
import MobileSearch from "./MobileSearch.js";

function Navbar(props) {
    const [toggle, setToggle] = useState(false);
    const [searchOpen, setSearchOpen] = useState(false);
    const user = useSelector((state) => state.user);
    const location = useLocation();

    // A route change (e.g. into edit mode and back) starts with search closed
    useEffect(() => setSearchOpen(false), [location.pathname, location.search]);

    // Hide search entry points in edit mode
    const isEditMode = new URLSearchParams(location.search).get("edit") === "true";
    // Below lg, an open mobile search takes the whole row; lg+ is never affected
    const mobileSearchOpen = searchOpen && !isEditMode;
    const hideWhenSearching = mobileSearchOpen ? 'tw-hidden lg:tw-block' : '';

    return (
        <nav className={`tw-w-full ${props.className}`}>
            <div
                className={`tw-mx-auto tw-flex tw-max-w-full tw-items-center tw-justify-between tw-pt-2 tw-relative ${
                    props.isGrayBackground ? 'tw-bg-backgroundGray' : 'tw-bg-transparent'
                }`}
            >

                {/* Brand: hidden below lg when mobile search is open */}
                <div className={`tw-flex-shrink-0 tw-z-30 ${hideWhenSearching}`}>
                    <NavbarBrand title={props.title} isGrayBackground={props.isGrayBackground}/>
                </div>

                <div className={`tw-flex tw-items-center tw-justify-end tw-gap-2 tw-pr-2 tw-z-30 ${mobileSearchOpen ? 'tw-flex-1 tw-min-w-0 lg:tw-flex-initial' : ''}`}>
                    {/* Desktop search (lg+), hidden in edit mode */}
                    {!isEditMode && (
                        <div className="tw-hidden lg:tw-block">
                            <SearchBar/>
                        </div>
                    )}

                    {/* Mobile search (below lg), hidden in edit mode */}
                    {!isEditMode && (
                        <div className={`lg:tw-hidden tw-flex tw-items-center ${mobileSearchOpen ? 'tw-flex-1 tw-min-w-0' : ''}`}>
                            <MobileSearch
                                open={searchOpen}
                                onOpen={() => setSearchOpen(true)}
                                onClose={() => setSearchOpen(false)}
                            />
                        </div>
                    )}

                    {/* Buttons: hidden below lg when mobile search is open */}
                    <div className={`tw-flex-shrink-0 ${hideWhenSearching}`}>
                        <NavbarButtons user={user} toggle={toggle} setToggle={setToggle}/>
                    </div>

                    {!user && (
                        <div className={`tw-flex-shrink-0 ${hideWhenSearching}`}>
                            <NavbarMenu toggle={toggle} setToggle={setToggle}/>
                        </div>
                    )}
                </div>
            </div>
        </nav>
    );
}

export default Navbar;
